import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="About Noadzdle" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500">
        This is an open source clone of the game Noadzdle -{' '}
        <a
          href="https://github.com/hannahcode/noadzdle"
          className="font-bold underline"
        >
          check out the code here
        </a>{' '}
        and{' '}
        <a
          href="https://www.powerlanguage.co.uk/noadzdle/"
          className="font-bold underline"
        >
          play the original here
        </a>
      </p>
    </BaseModal>
  )
}
